import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import logger from "../../../../../utils/logger";
import { addKeyResource } from "../../../../controller/reducer/keyResources";

const KeyResourceAddModal = ({ show, onClose, dispatch }) => {
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [email, setEmail] = useState("");
  const submitTask = (e) => {
    e.preventDefault();
    const data = {
      title,
      link,
      email,
      comment: "",
      type: "add",
    };
    logger()(data);
    dispatch(addKeyResource(data));
    onClose();
  };
  return (
    <Modal show={show} animation={false} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Suggest New Resource</Modal.Title>
      </Modal.Header>
      <Form onSubmit={submitTask}>
        <Modal.Body>
          <Form.Group controlId="title">
            <Form.Label>Enter Title*</Form.Label>
            <Form.Control
              maxLength="200"
              required
              type="text"
              placeholder="Title"
              value={title}
              onChange={(e) => setTitle(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">
              Suggest if it's authentic and important
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="link">
            <Form.Label>Enter Link*</Form.Label>
            <Form.Control
              required
              type="url"
              placeholder="Link"
              value={link}
              onChange={(e) => setLink(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">
              Verify your link before submitting
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Enter Email</Form.Label>
            <Form.Control
              maxLength="50"
              type="email"
              placeholder="Email Here"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <Form.Text className="text-muted">
              Enter email to receive response for your suggestion
            </Form.Text>
          </Form.Group>
          <Form.Text className="text-muted">* fields are mandatory</Form.Text>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default KeyResourceAddModal;
